export default {
  title: 'Ihr Fahrer',
  buttons: {
    track_driver: 'Lokführer',
  },
};
